//Button variants
export const VARIANTS = {
  PRIMARY: 'default',
  SELECTABLE_WITH_PANEL: 'selectableWithPanel',
  SUBTLE: 'subtle',
  SQUARE: 'square'
};

//Sizes
export const SIZES = {
  SMALL: 'small',
  REGULAR: 'regular',
  MEDIUM: 'medium'
};

//Colors
export const SQUARE_CHIP_COLORS = {
  CREAM: 'cream',
  NEGATIVE: 'negative'
};